import { render } from "./NavView.vue?vue&type=template&id=dce58140&scoped=true"
import script from "./NavView.vue?vue&type=script&lang=js"
export * from "./NavView.vue?vue&type=script&lang=js"

import "./NavView.vue?vue&type=style&index=0&id=dce58140&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Евадент\\eva\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dce58140"]])

export default __exports__